import React, { useState, useEffect } from "react"
import Layout from "../components/Layout/layout"
import { graphql, navigate } from "gatsby"
import Helmet from 'react-helmet';
import {
  SinglePageHeader,
  WebinarForm,
  Container,
  MarkdownContent,
  WebinarSidebar,
  WebinarCard,
  Grid
} from "../components"
import SkewBgHeader from "../components/common/SkewBgHeader/SkewBgHeader"

function WebinarTemplate({
  location,
  data: {
    dataYaml: { webinar, demo },
    markdownRemark: { frontmatter, html },
    allMarkdownRemark: { edges },
    site
  },
  pageContext: { language, dev },
}) {
  const url = site.siteMetadata.domain ? site.siteMetadata.domain : "https://autify.com";
  const data = {
    title: frontmatter.title,
    sub_title: frontmatter.description,
    image: url + frontmatter.image.childImageSharp.fluid.src,
    videoDuration: frontmatter.videoDuration,
  }
  const navigateTo = () => {
    const url = language === "en" ? "/thanks" : "/ja/thanks"
    navigate(url, {
      state: {
        thanksTitle: webinar.thanks.title,
        thanksSubtitle: webinar.thanks.subTitle,
      },
    })
  }

  const [archivedList, setArchivedList] = useState([])
  useEffect(() => {
    let archived = []
    edges.forEach(edge => {
      //if archived + show=true + not the same page
      if (!edge.node.frontmatter.upcoming && edge.node.frontmatter.show && location.pathname !== edge.node.frontmatter.slug) {

        if (!!frontmatter.recommendation) {
          const isRecommended = frontmatter.recommendation.find(element => element === edge.node.frontmatter.archivedId)
          if (!!isRecommended) {
            archived.push(edge)
          }
        }
      }
    })
    setArchivedList(archived)
  }, [])


  return (
    <Layout location={location} title={frontmatter.title} description={frontmatter.description} imageURL={data.image} hasCTA={false}>
      <Helmet>
        <meta property="og:type" content="article" />
      </Helmet>
      <SkewBgHeader
        topBgColor="gray"
        background="gray"
        color="green"
        bottomBgColor="white"
        skewBgColor="gray"
       >
         <Container>
          <SinglePageHeader
            title={data.title}
            image={frontmatter.image}
            badgeText={data.badgeText}
            videoDuration={data.videoDuration}
          />
        </Container>
      </SkewBgHeader>
      <Container className="webinar">
        <div className="row webinar__content">
          <WebinarSidebar frontmatter={frontmatter} webinar={webinar} language={language} />

          <div className="col-12 col-md-8">
            <MarkdownContent html={html} />
            {frontmatter.upcoming && !frontmatter.external_url && (
              <>
                <div>
                  <h2>{webinar.demo.title}</h2>
                  <p>{webinar.demo.subTitle}</p>
                </div>
                <WebinarForm
                  demo={demo}
                  webinarTitle={frontmatter.title}
                  webinar={webinar}
                  language={language}
                  navigateTo={navigateTo}
                  {...frontmatter}
                  dev={dev}
                />
              </>
            )}
          </div>
        </div>
      </Container>


      {/* archived recommendations */}
      <Container>
        {!frontmatter.upcoming && archivedList.length !== 0 && (
          <>
            <h3 style={{ marginBottom: 24 }}>{webinar.archivedWebinars}</h3>
            <Grid
              showComingSoon={false}
              common={webinar}
              data={archivedList}
              responsive={{ xs: 12, sm: 12, md: 6, lg: 4 }}
              card={WebinarCard}
            />
          </>
        )}
      </Container>
    </Layout>
  )
}
export const pageQuery = graphql`
  query($language: String, $slug: String) {
    site {
      siteMetadata {
        domain
      }
    }
    dataYaml(language: { eq: $language }) {
      demo {
        error_messages {
          company_name
          email
          first_name
          last_name
          no_personal_email
          too_many_signups
          company_size
          webinar_date
          phone
        }
        forms {
          question
          company_name
          company_size
          email
          first_name
          last_name
          phone
          webinarDate
        }
      }
      webinar {
        demo {
          subTitle
          title
          button
          errorMessage
        }
        watchNow
        webinars
        dateTime
        speakers
        methodOfParticipation
        participationFee
        targetAudience
        archivedWebinars
        hostedBy
        sponsorship
        demo {
          title
          subTitle
        }
        thanks {
          title
          subTitle
        }
      }
    }
    markdownRemark(
      frontmatter: { slug: { eq: $slug }, language: { eq: $language } }
      fileAbsolutePath: { regex: "/webinars/" }
    ) {
      id
      html
      frontmatter {
        date
        title
        slug
        description
        language
        speakers {
          avatar {
            childImageSharp {
              fixed(width: 40, height: 40) {
                ...GatsbyImageSharpFixed_withWebp
              }
            }
          }
          name
          position
        }
        method
        webinarId
        repeating
        fee
        upcoming
        videoDuration
        time
        audience
        hostedBy
        sponsored
        archivedId
        recommendation
        external_url
        image {
          childImageSharp {
            fluid(maxHeight: 316, maxWidth: 564) {
              ...GatsbyImageSharpFluid_withWebp
              src
            }
          }
        }
      }
    }
    allMarkdownRemark(
      filter: {
        fileAbsolutePath: { regex: "/webinars/" }
        frontmatter: { language: { eq: $language } }
      }
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            date(formatString: "l")
            language
            description
            upcoming
            webinarId
            videoDuration
            slug
            repeating
            show
            archivedId
            recommendation
            image {
              childImageSharp {
                fluid(maxHeight: 364) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    }
  }
`

export default WebinarTemplate
